<div class="d-flex auto-attendant-edit-container">
  <div class="container auto-attendant-edit-container__form">
    @if (!this.is360ViewChild) {
      <ziro-breadcrumbs [beta]="true">
        <ziro-breadcrumb-card-item [aboutCardId]="134"></ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
    }
    @if (isLoading()) {
      <ziro-loading-block></ziro-loading-block>
    } @else {
      <ziro-teams-auto-attendant-edit-form
        [entity]="generalSettingsEntity"
        [autoAttendantId]="autoAttendantId"
        [autoAttendantView]="autoAttendantView"
        [userPhotos]="userPhotos"
        [is360ViewChild]="is360ViewChild"
        [tenantId]="tenantId"
        [autoAttendantsFieldConfig]="autoAttendantsFieldConfig"
        [autoAttendantsHolidays]="autoAttendantsHolidays"
        [isLoading]="isLoading()"
        [isSaving]="isSaving()"
      ></ziro-teams-auto-attendant-edit-form>
    }
  </div>
</div>
